module.exports = __webpack_public_path__ + "static/img/dshlogo.c9b751b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dshlogo.png
// module id = TUeG
// module chunks = 4